/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const CircleContract = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 26 26">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12ZM24 12C24 8.8174 22.7357 5.76515 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76515 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12Z"
        fill="#21295C"
      />
      <path
        d="M5.30816 14.6941C5.50554 14.89 5.7732 15 6.05229 15C6.33138 15 6.59904 14.89 6.79641 14.6941L12.0064 9.52205L17.2163 14.6941C17.4148 14.8844 17.6807 14.9897 17.9566 14.9873C18.2326 14.985 18.4966 14.8751 18.6917 14.6814C18.8869 14.4876 18.9976 14.2256 19 13.9516C19.0024 13.6777 18.8963 13.4137 18.7045 13.2167L12.7505 7.30592C12.5531 7.11004 12.2854 7 12.0064 7C11.7273 7 11.4596 7.11004 11.2622 7.30592L5.30816 13.2167C5.11085 13.4126 5 13.6783 5 13.9554C5 14.2324 5.11085 14.4981 5.30816 14.6941Z"
        fill="#21295C"
      />
    </BaseSvgIcon>
  )
}

export default CircleContract
